import React, { useState, useEffect } from 'react';
import { Routes ,Route, Navigate } from 'react-router-dom';
import Header from '../components/layouts/header';
import Sidebar from '../components/layouts/sidebar';
import TwoColumn from '../components/layouts/two_column';
import Customizer from '../components/layouts/customizer';
import { Toaster } from 'react-hot-toast';
import axiosInstance from './axiosSetup.js';
import toast from 'react-hot-toast';

import EditProfile from '../components/profile/profile';
import Dashboard from '../components/dashboard_component';
import Roles from '../components/roles/role';
import Permissions from '../components/permissions/permissions';
import RolePermissions from '../components/rolePermissions/permission';
import Departments from '../components/department/departments';
import TaskTypes from '../components/task_types/tasktype';
import LeavesCredebility from '../components/leaves_credebility/leaves-credibility';
import MyCalendar from '../components/calender/calender';
import Holidays from '../components/holidays/holiday';
import Channels from '../components/channels/channel';
import InactiveChannels from '../components/channels/inactive-channels';
import Meter from '../components/meters/meter';
import InactiveMeter from '../components/meters/inactive-meter';
import Employees from '../components/employees/employees';
import InactiveEmployees from '../components/employees/inactive-employees';
import Clients from '../components/clients/client';
import InactiveClients from '../components/clients/inactive-clients';
import BasicProjects from '../components/basic_projects/basic-project';
import Projects from '../components/projects/project';
import CompletedProjects from '../components/projects/completed-projects';
import OnHoldProjects from '../components/projects/onHold-projects';
import InactiveProjects from '../components/projects/inactive-projects';
import ProjectMeter from '../components/projectMeter/projectMeter';
import InactiveProjectMeter from '../components/projectMeter/inactive-projectMeter';
import AssignProject from '../components/assign_project/assign-project';
import Leaves from '../components/leaves/leaves';
import AdminLeaves from '../components/leaves/adminleaves';
import QA from '../components/qa/qa';
import Announcement from '../components/announcement/announcement';
import AllAnnouncements from '../components/announcement/all-announcements';
import AcknowledgedAnnouncement from '../components/announcement/acknowledgedAnnouncement';
import AssignedProjects from '../components/assigned_projects/assigned_project';
import TimeLog from '../components/timelog/timelog';
import AdminMrngTimeLog from '../components/timelog/adminMrngTimelog';
import AdminEveTimeLog from '../components/timelog/adminEveTimelog';
import EMNotFilled from '../components/reports/daily_reports/em-not-filled';
import TLApprovalPending from '../components/reports/daily_reports/tl-approval-pending';
import ProjectReport from '../components/reports/project_reports/project-report';
import ClientWiseReport from '../components/reports/project_reports/client-wise-report';
import AnnouncementModal from './announcementModal';


const MainComponent = () => {
    const user = JSON.parse(localStorage.getItem('userInfo'));
    const [showModal, setShowModal] = useState(false);
    const [announcements, setAnnouncements] = useState([]);
    const [currentAnnouncementIndex, setCurrentAnnouncementIndex] = useState(0);


    useEffect(() => {
        const scriptUrl = `${process.env.REACT_APP_URL}/assets/js/theme-settings.js`;
        const scriptId = 'theme-settings-script';

        // Check if script is already loaded based on localStorage
        const isScriptLoaded = localStorage.getItem('themeScriptLoaded') === 'true';
        
        if (!isScriptLoaded) {
            const themeScript = document.createElement('script');
            themeScript.src = scriptUrl;
            themeScript.async = true;
            themeScript.type = 'text/javascript';
            themeScript.id = scriptId;
            
            // Append the script to the document
            document.body.appendChild(themeScript);
            localStorage.setItem('themeScriptLoaded', 'true');

            return () => {
                const scriptToRemove = document.getElementById(scriptId);
                if (scriptToRemove) {
                    document.body.removeChild(scriptToRemove);
                    localStorage.removeItem('themeScriptLoaded');
                }
            };
        }
    }, []);
    
    // Show the modal when the component mounts
    useEffect(() => {
        setShowModal(true);
        fetchAnnouncements(user.id);
    }, []);

    const fetchAnnouncements = async (id) => {
        try {
            const response = await axiosInstance.get(`${process.env.REACT_APP_API_URL}/getAnnouncementByUser/${id}?showAll=true`);
            const data = response.data.data || [];

            setAnnouncements(data);

            if (data.length > 0) {
                setShowModal(true);
            }
        } catch (error) {
            console.error("Error fetching announcements", error);
            setAnnouncements([]);
        }
    };

    const handleCloseModal = (id) => {
        acceptAnnouncement(id);

        if (currentAnnouncementIndex < announcements.length - 1) {
            setCurrentAnnouncementIndex(currentAnnouncementIndex + 1);
        } else {
            setShowModal(false); // all modals done
        }
    };

    const acceptAnnouncement = async (id) => {
        try {
            const response = await axiosInstance.post(`${process.env.REACT_APP_API_URL}/acknowledgeAnnouncement/${id}`);
            toast.success(response.data.message || "Announcement accepted successfully");
        } catch (error) {
            toast.error(error.response?.data?.message || "Error accepting announcement");
        }
    };

    return (
        <>
            <Toaster position="top-right" />
            <div className="main-wrapper">
                <Header />
                <Sidebar />
                <TwoColumn />


                {/* DYNAMIC-Content */}
                <div className="page-wrapper">

                    {/* Main Component with Routing */}
                    <Routes>

                        {/* ------------------------------------------------------- */}
                        {/* -------------- CATCH - ALL ROUTES for 404 ------------- */}

                        <Route path="*" element={<Navigate to="/dashboard" replace />} />

                        {/* ------------------------- END ------------------------- */}
                        {/* ------------------------------------------------------- */}


                        <Route index exact path='dashboard' element={<Dashboard />} /> 
                        <Route exact path="profile" element={<EditProfile employeeId={user.id} />} />
                        <Route exact path='roles' element={<Roles />} />
                        <Route exact path='permissions' element={<Permissions />} />
                        <Route exact path='role-permission' element={<RolePermissions />} />
                        <Route exact path='departments' element={<Departments />} />
                        <Route exact path='task-types' element={<TaskTypes />} />
                        <Route exact path='leaves-credebility' element={<LeavesCredebility />} />
                        <Route exact path='basic-projects' element={<BasicProjects />} />
                        <Route exact path='employees' element={<Employees />} />
                        <Route exact path='channels' element={<Channels />} />
                        <Route exact path='clients' element={<Clients />} />
                        <Route exact path='meter' element={<Meter />} />
                        <Route exact path='project-meter' element={<ProjectMeter />} />
                        <Route exact path='assign-project' element={<AssignProject />} />
                        <Route exact path='calendar' element={<MyCalendar />} />
                        <Route exact path='holidays' element={<Holidays />} />
                        <Route exact path='qa' element={<QA />} />
                        <Route exact path='announcements' element={<Announcement />} />
                        <Route exact path='all-announcements' element={<AllAnnouncements />} />
                        <Route exact path='acknowledgedAnnouncement/:id' element={<AcknowledgedAnnouncement />} />

                        <Route exact path='timelog' element={user.role_name === 'Super-Admin' ? <Navigate to="/timelog/manageTimeMorning" replace /> : <TimeLog />} />
                        <Route exact path='projects' element={<Projects />} />
                        <Route exact path='assigned-projects' element={<AssignedProjects />} />
                        <Route exact path='leaves' element={user.role_name === 'Employee' ? <Leaves /> : <AdminLeaves />} />

                        <Route exact path='inactive-channels' element={<InactiveChannels />} />
                        <Route exact path='inactive-clients' element={<InactiveClients />} />
                        <Route exact path='inactive-meter' element={<InactiveMeter />} />
                        <Route exact path='completed-projects' element={<CompletedProjects />} />
                        <Route exact path='on-hold-projects' element={<OnHoldProjects />} />
                        <Route exact path='inactive-projects' element={<InactiveProjects />} />
                        <Route exact path='inactive-project-meter' element={<InactiveProjectMeter />} />
                        <Route exact path='timelog/manageTimeMorning' element={<AdminMrngTimeLog />} />
                        <Route exact path='timelog/manageTimeEvening' element={<AdminEveTimeLog />} />
                        <Route exact path='inactive-employees' element={<InactiveEmployees />} />



                        {/* -------------------- Report Routes - START -------------------- */}

                        <Route exact path='em-not-filled' element={<EMNotFilled />} />
                        <Route exact path='tl-approval-pending' element={<TLApprovalPending />} />
                        <Route exact path='project-reports' element={<ProjectReport />} />
                        <Route exact path='client-wise-reports' element={<ClientWiseReport />} />

                        {/* --------------------- Report Routes - END --------------------- */}
                    </Routes>

                </div>
                {/* END:DYNAMIC-Content */}
            </div>

            {/* CUSTOMIZER-Panel */}
            <div className="settings-icon">
                <span data-bs-toggle="offcanvas" data-bs-target="#theme-settings-offcanvas"
                    aria-controls="theme-settings-offcanvas"><i className="las la-cog"></i></span>
            </div>
            <Customizer />
            {/* END:CUSTOMIZER-Panel */}


            {/* Announcement */}
            {announcements.length > 0 && showModal && user.role_name !== 'Super-Admin' && (
                <AnnouncementModal 
                    showModal={showModal} 
                    handleCloseModal={handleCloseModal}
                    data={announcements[currentAnnouncementIndex]}
                />
            )}
        </>
    );
}

export default MainComponent